import type { APIBookingDraft, APIBookingDraftError } from '@/scopes/checkout/infrastructure/api/types'
import { BookingDraftErrorMapper, createBookingDraftErrorMapper } from '@/scopes/checkout/infrastructure/api/model-mappers/bookingDraftErrorMapper'
import { RyanairSessionData } from '../../domain/types/ryanairSessionData'

export interface RyanairSessionResponseMapper {
  map: (bookingDraft: APIBookingDraft) => RyanairSessionData
}

export interface Dependencies {
  errorMapper: BookingDraftErrorMapper
}

export function createRyanairSessionResponseMapper(dependencies: Partial<Dependencies>): RyanairSessionResponseMapper {
  const {
    errorMapper = createBookingDraftErrorMapper(),
  } = dependencies
  const map = (bookingDraft: APIBookingDraft) => {
    const error = errorMapper.map(bookingDraft.error as APIBookingDraftError)
    const result: RyanairSessionData = {
      error: error || undefined,
    }

    if (!error?.hasError) {
      result.iFrameUrl = bookingDraft.externalDataInfo?.ryanairData?.urlIFrame
    }

    return result
  }

  return {
    map,
  }
}
